import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-lessors-selector",
  templateUrl: "./lessors-selector.component.html",
  styleUrls: ["./lessors-selector.component.css"],
})
export class LessorsSelectorComponent implements OnInit {
  @Input() isEditing: boolean;
  @Input() lessors = [];
  @Input() isDefaultLessor: boolean = false;
  @Output() isDefaultLessorChange = new EventEmitter();
  @Input() selectedLessors = [];
  @Output() selectedLessorsChange = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  // sort so that the selected drivers are at the top, ties broken by name
  sortSelected() {
    const selected = this.selectedLessors.filter((d) => d != undefined);
    const notSelected = this.lessors.filter((d) => !selected.some((s) => s?.id === d?.id));
    selected.sort((a, b) => a.name - b.name);
    notSelected.sort((a, b) => a.name - b.name);
    this.lessors = [...selected, ...notSelected];
    console.log("lessors2", this.lessors);
  }
}
